import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";

/** @jsx jsx */
import React from 'react';
import ReactDOM from 'react-dom';
import { css, jsx } from '@emotion/core'; // todo: look at Fin’s latest status modal work in access-boston
// todo: add an error state (i.e. red text, “error” label)

var MODAL_STYLE = css({
  paddingTop: 0,
  maxWidth: 500,
  top: '15%',
  marginRight: 'auto',
  marginLeft: 'auto'
});
var WAITING_MODAL_STYLE = css({
  cursor: 'wait'
});
/**
 * Modal component intended to provide a clear “waiting” state to the user.
 * “message” string is used to label the modal, providing better clarity when
 * viewed via screen reader.
 *
 * Suggested child:
 *
 * <div className="t--info m-t300">
 *   Please be patient and don’t refresh your browser. This might take a bit.
 * </div>
 *
 * Add the `Container` element to the DOM in _document.tsx so that screen
 * readers will pick up on the modal automatically when it’s added.
 */

var StatusModal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(StatusModal, _React$Component);

  function StatusModal() {
    _classCallCheck(this, StatusModal);

    return _possibleConstructorReturn(this, _getPrototypeOf(StatusModal).apply(this, arguments));
  }

  _createClass(StatusModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          message = _this$props.message,
          error = _this$props.error,
          waiting = _this$props.waiting,
          onClose = _this$props.onClose,
          hideTopBorderDecoration = _this$props.hideTopBorderDecoration,
          absoluteCloseBtn = _this$props.absoluteCloseBtn;
      var alertHolder = document.getElementById(StatusModal.ALERT_CONTAINER_ID);
      var topBorderDecorationCss = !hideTopBorderDecoration ? " br br-t400" : '';
      var alertContent = jsx("div", {
        className: "md",
        css: waiting && WAITING_MODAL_STYLE
      }, jsx("div", {
        className: "md-c".concat(topBorderDecorationCss),
        css: MODAL_STYLE
      }, absoluteCloseBtn && jsx("button", {
        className: "md-cb",
        type: "button",
        onClick: onClose,
        autoFocus: true
      }, "Close"), jsx("div", {
        className: "md-b p-a300"
      }, message && jsx("div", {
        className: "t--intro ".concat(error ? 't--err' : '')
      }, message), children, onClose && !absoluteCloseBtn && jsx("div", {
        className: "m-t300 ta-r"
      }, jsx("button", {
        className: "btn btn--sm btn--100",
        type: "button",
        onClick: onClose,
        autoFocus: true
      }, "Close")))));

      if (alertHolder) {
        return ReactDOM.createPortal(alertContent, alertHolder);
      } else {
        if (process.env.NODE_ENV !== 'test') {
          // eslint-disable-next-line no-console
          console.warn('Portal not found. Add StatusModal.makeStatusModalContainer to _document.tsx');
        }

        return alertContent;
      }
    }
  }], [{
    key: "Container",

    /**
     * Adds an "alert"-roled element to the page that the modal can `Portal` into.
     * This gets around a limitation of certain screen readers that don’t announce
     * live elements when they’re dynamically added to the page.
     */
    value: function Container() {
      return jsx("div", {
        role: "alert",
        "aria-atomic": true,
        id: StatusModal.ALERT_CONTAINER_ID
      });
    }
  }]);

  return StatusModal;
}(React.Component);

StatusModal.ALERT_CONTAINER_ID = 'status-modal';
export { StatusModal as default };